export default "__VITE_ASSET__DHOYsW26__"